import { useEffect, useState } from 'react';

/**
 * @deprecated use `demo-middleware` instead
 * TODO (Justas): Delete during https://castai.atlassian.net/browse/UI-5682
 */
export const useDataOrFixture = <T>(
  data: T | undefined,
  fixture: () => Promise<T>,
  showFixture: boolean
): T | undefined => {
  const [fixtureData, setFixtureData] = useState(data);

  useEffect(() => {
    if (showFixture) {
      fixture().then((fixtureData) => {
        setFixtureData(fixtureData);
      });
    }
  }, [fixture, showFixture]);

  return showFixture ? fixtureData : data;
};
